import React from "react";
import { FiUsers, FiBook, FiCalendar, FiMapPin, FiUser, FiInfo } from "react-icons/fi";

const weekdays = [
  { value: "mon", label: "Thứ 2" },
  { value: "tue", label: "Thứ 3" },
  { value: "wed", label: "Thứ 4" },
  { value: "thu", label: "Thứ 5" },
  { value: "fri", label: "Thứ 6" },
  { value: "sat", label: "Thứ 7" },
  { value: "sun", label: "Chủ nhật" },
];

function renderSchedule(schedule = []) {
  const map = {};
  schedule.forEach(sch => {
    sch.days?.forEach(day => {
      if (!map[day]) map[day] = [];
      if (sch.startTime && sch.endTime) map[day].push(`${sch.startTime}-${sch.endTime}`);
    });
  });
  const weekOrder = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
  return weekOrder
    .filter(day => map[day]?.length)
    .map(day => (
      <div key={day} className="flex items-center gap-2">
        <span className="font-semibold">{weekdays.find(w => w.value === day)?.label}:</span>
        <span>{map[day].join(", ")}</span>
      </div>
    ));
}

export default function TabInfo({ classInfo, students = [], teachers = [], programs = [], isAdmin }) {
  const program =
    programs.find((p) => p.id === classInfo.programId) || {};
  const teacherList = teachers;
  const numStudents = Array.isArray(classInfo.studentIds)
    ? classInfo.studentIds.length
    : Array.isArray(students)
      ? students.length
      : 0;
  const maxStudents = classInfo.maxStudents || "";

  return (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-[15px]">
        {/* Cột trái */}
        <div className="space-y-3">
          <div className="flex items-center gap-2 text-lg font-bold text-primary">
            <FiInfo className="text-primary" />
            {classInfo.name}
            {classInfo.status === "active" ? (
              <span className="ml-2 px-2 py-0.5 text-xs rounded-xl bg-success text-text font-semibold border border-success/30">
                Đang hoạt động
              </span>
            ) : (
              <span className="ml-2 px-2 py-0.5 text-xs rounded-xl bg-border text-text2 font-semibold border border-border">
                Ngừng hoạt động
              </span>
            )}
          </div>
          <div className="flex items-center gap-2">
            <FiBook className="text-menu" />
            <span className="font-semibold">Chương trình học:</span>{" "}
            <span className="ml-1">
              {program.name?.vi || program.name?.en || program.level?.vi || "-"}
            </span>
          </div>
          <div className="flex items-center gap-2">
            <FiCalendar className="text-menu" />
            <span className="font-semibold">Ngày khai giảng:</span>{" "}
            <span className="ml-1">
              {classInfo.startDate
                ? new Date(classInfo.startDate).toLocaleDateString("vi-VN")
                : "-"}
            </span>
          </div>
          <div className="flex items-center gap-2">
            <FiCalendar className="text-menu" />
            <span className="font-semibold">Ngày kết thúc:</span>{" "}
            <span className="ml-1">
              {classInfo.endDate
                ? new Date(classInfo.endDate).toLocaleDateString("vi-VN")
                : "-"}
            </span>
          </div>
          <div className="flex items-center gap-2">
            <FiMapPin className="text-menu" />
            <span className="font-semibold">Phòng học:</span>{" "}
            <span className="ml-1">
              {classInfo.room || <span className="text-text2">-</span>}
            </span>
          </div>
          <div className="flex items-center gap-2">
            <FiUsers className="text-menu" />
            <span className="font-semibold">Sĩ số:</span>{" "}
            <span className="ml-1">
              {numStudents}
              {maxStudents ? ` / ${maxStudents}` : ""}
            </span>
          </div>
        </div>
        {/* Cột phải */}
        <div className="space-y-3">
          <div>
            <span className="font-semibold">Lịch học:</span>
            <div className="ml-2 mt-1 space-y-0.5">
              {renderSchedule(classInfo.schedule)}
            </div>
          </div>
          <div>
            <span className="font-semibold">Giáo viên:</span>
            <ul className="ml-4 mt-1 list-disc">
              {teacherList.length
                ? teacherList.map((t, idx) =>
                    t ? (
                      <li key={t.id} className="flex items-center gap-1">
                        <FiUser className="text-menu" />
                        <span>
                          {t.firstName} {t.lastName}{" "}
                          <span className="text-text2">({t.email})</span>
                        </span>
                      </li>
                    ) : (
                      <li key={classInfo.teacherIds[idx]}>
                        {classInfo.teacherIds[idx]}
                      </li>
                    )
                  )
                : (
                  <li className="italic text-text2">Chưa có giáo viên</li>
                )}
            </ul>
          </div>
          {classInfo.description && (
            <div>
              <span className="font-semibold">Mô tả:</span>{" "}
              <span className="italic">{classInfo.description}</span>
            </div>
          )}
          {isAdmin && classInfo.adminNote && (
            <div>
              <span className="font-semibold">Ghi chú admin:</span>{" "}
              <span className="italic text-error">{classInfo.adminNote}</span>
            </div>
          )}
          <div className="text-xs text-text2 mt-3 select-all">
            ID lớp: {classInfo.id}
          </div>
        </div>
      </div>
  );
}
